/**
 * The caption window title for a stats tile: the text the tile shows. Stats
 * tiles are not copilot shortcuts, so nothing else names them, and without
 * this the window falls back to the graphic id (gfx_PermScore). Single tiles
 * show `label`; Double and Advanced tiles show `title`.
 */
export const statTileTitle = (stat) => stat?.label || stat?.title || stat?.name;

/**
 * The line under the title: a Double tile's two stat names. Double headings
 * repeat ("2nd Half Statistics" covers two tiles), so these say which one.
 */
export const statTileSubtitle = (stat) =>
  [stat?.stat1?.title, stat?.stat2?.title].filter(Boolean).join(' / ');
